import type { IntlShape } from 'react-intl';
import { config } from '../../../config';

const CURRENT_VERSION = config.serviceVersion;
const RELEASE_NOTES_ENTRY_PREFIX = `assets.release-notes.entry.${CURRENT_VERSION}.`;
export const RELEASE_NOTES_RELEASE_DATE_ID = `${RELEASE_NOTES_ENTRY_PREFIX}release-date`;

const MAX_AGE_DAYS = 60;
const MAX_AGE_MS = 24 * 60 * 60 * 1000 * MAX_AGE_DAYS;

export const shouldShowReleaseNotes = (intl: IntlShape) => {
    const lastReleaseDate = Date.parse(
        intl.formatMessage({
            id: RELEASE_NOTES_RELEASE_DATE_ID,
        })
    );

    return Number.isFinite(lastReleaseDate) && Date.now() - lastReleaseDate <= MAX_AGE_MS;
};
